<template>
  <div class="content">
    <!-- <div class="top">
      <div class="info">
        <img
          :src="avatarUrl"
          style="width: 80px; margin-left: 5px; margin-bottom: 20px"
          alt=""
        /><span style="font-size: 18px; color: #333333; margin-bottom: 20px">{{
          userInfo?.userName
        }}</span
        ><span style="font-size: 14px; color: #999999">{{
          userInfo?.deptName
        }}</span>
      </div>
    </div> -->
    <div class="bottom">
      <div
        style="
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          margin-bottom: 20px;
        "
      >
        登录历史
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 20px">
        <span>筛选日期：</span>
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="changeDateRange"
          @clear="handleClear"
        >
        </el-date-picker>
      </div>
      <div class="table">
        <div style="margin-bottom: 12px">
          <span style="font-size: 14px; color: #333333">{{
            $t("profile.logsPage.logsDesc")
          }}</span
          ><span
            style="font-size: 14px; color: #6293ff; cursor: pointer"
            @click="toChangePwd()"
            >{{ $t("profile.logsPage.changePwd") }}</span
          >
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="browser" label="浏览器"> </el-table-column>
          <el-table-column prop="os" label="操作系统"> </el-table-column>
          <el-table-column prop="loginWay" label="登录方式"> </el-table-column>
          <el-table-column prop="msg" label="提示信息"> </el-table-column>
          <el-table-column prop="loginTime" label="登录时间"> </el-table-column>
        </el-table>
        <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[10, 30, 60, 120]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPages"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 35px"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
export default {
  data() {
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      tableData: [],
      userInfo: {},
      currentPage: 1,
      pageSize: 10,
      totalPages: 0,
      dateValue: "",
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  created() {
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.avtor = this.userInfo?.avatar;
    this.getTableData();
  },
  methods: {
    handleClear() {
      console.log("日期已清除");
      // 可在这里执行清除后的逻辑，如重置相关数据、校验等
      // 例如：this.relatedData = null;
      this.getTableData()
    },
    changeDateRange(value) {
      console.log(value);
      this.getTableData(value?.[0], value?.[1]);
    },
    handleSizeChange(data) {
      this.pageSize = data;
      this.getTableData("","");
    },
    handleCurrentChange(data) {
      this.currentPage = data;
      this.getTableData("","");
    },
    getTableData(start, end) {
      request({
        url: `/api/user/loginlog`,
        method: "post",
        data: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          beginTime: start,
          endTime: end,
        },
      })
        .then((res) => {
          this.tableData = [...res?.rows];
          this.totalPages = res?.total;
        })
        .catch((error) => {});
    },
    toChangePwd() {
      this.$emit("toComponent", undefined, "editPassword");
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: column;
  padding: 20px;
  .top {
    height: 280px;
    background-image: url("@/assets/img/personal/accountBg.png");
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    border-bottom: 1px solid #dfdfdf;
    position: relative;
    .info {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 17%;
      left: 5%;
    }
  }
  .center {
    padding: 15px;
    width: 100%;
    .title {
      border-left: 3px solid #6293ff;
      padding-left: 8px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-size: 16px;
      color: #333333;
    }
    .basic {
      font-size: 14px;
      color: #666666;
      background: #f5f7fb;
      border-radius: 4px 4px 4px 4px;
      padding: 20px;
    }
  }
  .bottom {
    padding: 15px;
    width: 100%;
    ::v-deep .el-table__header th {
      background-color: #f5f7fb;
      font-weight: bold;
      color: #333333;
    }
    .title {
      border-left: 3px solid #6293ff;
      padding-left: 8px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-size: 16px;
      color: #333333;
    }
  }
}
</style>
